import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { listMyBookmarks, listDomains } from "@/lib/academy.functions";
import { AcademyNav } from "@/components/academy/AcademyNav";
import { Bookmark } from "lucide-react";

export const Route = createFileRoute("/_authenticated/academy/saved")({
  head: () => ({ meta: [{ title: "Saved Lessons · Academy" }, { name: "robots", content: "noindex" }] }),
  component: SavedPage,
});

function SavedPage() {
  const bookmarks = useQuery({ queryKey: ["academy", "bookmarks"], queryFn: () => listMyBookmarks() });
  const domains = useQuery({ queryKey: ["academy", "domains"], queryFn: () => listDomains() });
  const dmap = new Map((domains.data ?? []).map((d) => [d.id, d.slug]));

  return (
    <>
      <AcademyNav />
      <div className="min-h-dvh bg-obsidian text-foreground">
        <section className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
          <p className="text-xs uppercase tracking-[0.3em] text-gold flex items-center gap-2"><Bookmark size={14}/> Saved</p>
          <h1 className="mt-2 font-serif text-3xl text-gold-luminous">Your bookmarked lessons.</h1>

          <ul className="mt-6 grid gap-3 sm:grid-cols-2">
            {(bookmarks.data ?? []).map((b: any) => {
              const l = b.academy_lessons;
              if (!l) return null;
              const dslug = dmap.get(l.domain_id) ?? "human-design";
              return (
                <li key={b.lesson_id}>
                  <Link to="/academy/$domain/lesson/$lesson" params={{ domain: dslug, lesson: l.slug }}
                    className="block rounded-2xl border hairline p-4 hover:border-gold/60">
                    <p className="font-serif text-base">{l.title}</p>
                    {l.summary && <p className="mt-1 line-clamp-2 text-xs text-foreground/60">{l.summary}</p>}
                  </Link>
                </li>
              );
            })}
            {(bookmarks.data ?? []).length === 0 && (
              <li className="text-sm text-foreground/60">No bookmarks yet. <Link to="/academy/library" className="text-gold">Explore the library →</Link></li>
            )}
          </ul>
        </section>
      </div>
    </>
  );
}
